import { Check, Zap, Crown } from 'lucide-react'

const PLANS = [
  {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: 'forever',
    description: 'Get started with basic AI writing tools.',
    icon: Zap,
    iconColor: '#475569',
    iconBg: '#f1f5f9',
    features: [
      '1 SOP / Synopsis / Research Paper',
      '1 Thesis (up to 3 chapters)',
      'Research Assistant (10 queries/mo)',
      '5 MB file storage',
    ],
    cta: 'Current plan',
    current: true,
  },
  {
    id: 'scholar',
    name: 'Scholar',
    price: '$19',
    period: 'per month',
    description: 'Everything you need for your PhD journey.',
    icon: Crown,
    iconColor: '#2563eb',
    iconBg: '#eff6ff',
    highlight: true,
    features: [
      'Unlimited SOPs, Synopses & Papers',
      'Full thesis with unlimited chapters',
      'Research Assistant (unlimited)',
      'Quality Review & Version History',
      'PDF context injection',
      '2 GB file storage',
    ],
    cta: 'Upgrade to Scholar',
    current: false,
  },
  {
    id: 'pro',
    name: 'Scholar Pro',
    price: '$39',
    period: 'per month',
    description: 'For power users and research teams.',
    icon: Crown,
    iconColor: '#7c3aed',
    iconBg: '#faf5ff',
    features: [
      'Everything in Scholar',
      'Priority AI generation (faster)',
      'Collaborative thesis writing',
      'Custom AI personas',
      '10 GB file storage',
      'Priority support',
    ],
    cta: 'Upgrade to Pro',
    current: false,
  },
]

export default function BillingPage() {
  return (
    <div className="min-h-screen p-8" style={{ background: '#f8fafc' }}>
      <div className="max-w-4xl mx-auto">

        {/* Header */}
        <div className="mb-10">
          <h1 className="font-display text-2xl font-bold text-slate-900 mb-2">Billing & Plans</h1>
          <p className="font-sans text-sm text-slate-500">Choose the plan that fits your research journey.</p>
        </div>

        {/* Plan cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PLANS.map(plan => {
            const Icon = plan.icon
            return (
              <div
                key={plan.id}
                className="rounded-2xl p-6 flex flex-col"
                style={{
                  background: '#ffffff',
                  border: plan.highlight ? '2px solid #2563eb' : '1px solid #e2e8f0',
                  boxShadow: plan.highlight ? '0 0 0 4px rgba(37,99,235,0.08)' : '0 1px 3px rgba(15,23,42,0.06)',
                  position: 'relative',
                }}
              >
                {plan.highlight && (
                  <div
                    className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full font-mono text-xs font-semibold"
                    style={{ background: '#2563eb', color: '#ffffff' }}
                  >
                    MOST POPULAR
                  </div>
                )}

                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center"
                    style={{ background: plan.iconBg }}>
                    <Icon style={{ width: 18, height: 18, color: plan.iconColor }} />
                  </div>
                  <div>
                    <p className="font-display font-semibold text-slate-900">{plan.name}</p>
                    <p className="font-sans text-xs text-slate-400">{plan.description}</p>
                  </div>
                </div>

                <div className="mb-6">
                  <span className="font-display text-3xl font-bold text-slate-900">{plan.price}</span>
                  <span className="font-sans text-sm text-slate-400 ml-1">/ {plan.period}</span>
                </div>

                <ul className="space-y-2.5 flex-1 mb-6">
                  {plan.features.map(f => (
                    <li key={f} className="flex items-start gap-2.5">
                      <div className="w-4 h-4 rounded-full flex items-center justify-center shrink-0 mt-0.5"
                        style={{ background: plan.highlight ? '#eff6ff' : '#f1f5f9' }}>
                        <Check style={{ width: 10, height: 10, color: plan.highlight ? '#2563eb' : '#475569' }} />
                      </div>
                      <span className="font-sans text-sm text-slate-600">{f}</span>
                    </li>
                  ))}
                </ul>

                <button
                  disabled={plan.current}
                  className="w-full py-2.5 rounded-xl font-sans text-sm font-semibold transition-all disabled:opacity-60 disabled:cursor-default"
                  style={{
                    background: plan.current ? '#f1f5f9' : plan.highlight ? '#2563eb' : '#eff6ff',
                    color: plan.current ? '#94a3b8' : plan.highlight ? '#ffffff' : '#2563eb',
                    border: plan.highlight ? 'none' : `1px solid ${plan.current ? '#e2e8f0' : '#bfdbfe'}`,
                  }}
                >
                  {plan.cta}
                </button>
              </div>
            )
          })}
        </div>

        {/* Footer note */}
        <p className="text-center font-sans text-xs text-slate-400 mt-8">
          Payments handled securely via Stripe. Cancel anytime. Prices in USD.
        </p>
      </div>
    </div>
  )
}
